import SolutionsAIAgent from 'components/SolutionsAIAgent/SolutionsAIAgent'
import '../SolutionsPage.css'

const CustomerExperience = () => {
  return (
    <div>
      <SolutionsAIAgent />
    </div>
  )
}

export default CustomerExperience
